import { post } from './post';

/**
 * API endpoint call for sending a request to create a new Service Provider entry
 * <code>
 * const addServiceResult = await addService(model)
 * </code>
 */
export const addService = async (model, reCaptchaToken) =>
  post('/v1/service', model, reCaptchaToken);
